module.exports = __webpack_public_path__ + "h5/img/di6.aa6cadbb.png";